import { getE2eAccessToken } from '@/auth/sessionStorage';
import { useAuth } from '@/auth/useAuth';
import { buildCookieAuthToken } from '@/shared/data/client';

export const useIsAuthenticated = (): boolean => {
  const { session, loading } = useAuth();
  if (loading) {
    return false;
  }
  if (getE2eAccessToken()) {
    return true;
  }
  return Boolean(session?.userId);
};

export const useAccessToken = (): string | null => {
  const { session, loading } = useAuth();
  if (loading) {
    return null;
  }
  const e2eToken = getE2eAccessToken();
  if (e2eToken) {
    return e2eToken;
  }
  if (!session?.userId) {
    return null;
  }
  return buildCookieAuthToken(session.userId);
};
